import { createAction, props } from '@ngrx/store';
import { AppUserState } from '../states/app.state';


export const initApp = createAction('[App] Init');

export const loadCurrentUser = createAction('[User] Load Current User');

export const setCurrentUser = createAction(
  '[User] Set Current User',
  props<{ currentUser: AppUserState; }>()
);

export const updateUserSettings = createAction(
  '[User] Update User Settings',
  props<{ settings: any; }>()
);

export const clearCurrentUser = createAction('[User] Clear Current User');
